import React from 'react';
import { Link, useParams } from 'react-router-dom';
import SeoHead from './SeoHead';
import { colors } from '../styles/designSystem';

const NotFound = () => {
  const { lang = 'en' } = useParams();
  const currentLang = ['fr', 'en', 'de'].includes(lang) ? lang : 'en';
  const copy = {
    fr: ['Page introuvable', 'La page demandée n’existe pas ou a été déplacée.', 'Retour à l’accueil'],
    en: ['Page not found', 'The requested page does not exist or has moved.', 'Back to home'],
    de: ['Seite nicht gefunden', 'Die angeforderte Seite existiert nicht oder wurde verschoben.', 'Zur Startseite'],
  }[currentLang];
  return <main className="py-24 bg-gradient-to-b from-gray-50 to-gray-100 min-h-[70vh] text-center">
    <SeoHead lang={currentLang} title={`${copy[0]} | Sonitrix`} description={copy[1]} noindex />
    <div className="max-w-3xl mx-auto px-4"><h1 className={`${colors.text.heading} ${colors.primary.text} text-4xl mb-6`}>{copy[0]}</h1><p className={`${colors.text.body} mb-8`}>{copy[1]}</p><Link className="text-violet-600 hover:text-violet-700 font-medium" to={`/${currentLang}/`}>{copy[2]}</Link></div>
  </main>;
};

export default NotFound;
